import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const MULTI_SELECTION: ObjectTypeConfig = {
  actions: [
    {
      id: "open",
      surfaces: ["selection-bar", "left-rail"],
      presentation: {
        "selection-bar": "icon-button",
        "left-rail": "menu-item",
      },
      hiddenWhen: { not: { state: "selectionSingle" } },
    },
    {
      id: "rename",
      surfaces: ["selection-bar"],
      presentation: "icon-button",
      hiddenWhen: { not: { state: "canRenameSelection" } },
    },
    {
      id: "bulk-move",
      surfaces: ["selection-bar", "left-rail"],
      presentation: {
        "selection-bar": "icon-button",
        "left-rail": "menu-item",
      },
      hiddenWhen: { state: "hasChatsInSelection" },
    },
    // Canvas multi-select "More" menu (context-menu surface). These are canvas
    // node operations and are intentionally absent from the workspace-list
    // selection bar, which is surface-filtered to the icon-button entries above.
    {
      id: "copy",
      surfaces: ["context-menu"],
      presentation: "menu-item",
    },
    {
      id: "wrap-in-section",
      surfaces: ["context-menu"],
      presentation: "menu-item",
    },
    {
      id: "bring-to-front",
      surfaces: ["context-menu"],
      presentation: "menu-item",
    },
    {
      id: "send-to-back",
      surfaces: ["context-menu"],
      presentation: "menu-item",
    },
    // Lock the selection's unlocked lockable nodes; the handler is withheld
    // when there are none. An all-locked selection gets the Unlock toolbar.
    {
      id: "lock",
      surfaces: ["context-menu"],
      presentation: "menu-item",
    },
    // Hide on canvas — the non-destructive group counterpart to bulk delete;
    // same semantics as the single-node action (nodes stay, the surface stops
    // rendering them; un-hiding lives on the canvas rail).
    {
      id: "remove-from-canvas",
      surfaces: ["context-menu"],
      presentation: "menu-item",
    },
    {
      // Group promotion: applies to the container files in the selection and
      // only them — mixed selections (references, widgets, connector
      // entities) skip the ineligible rest. Hidden when nothing can promote.
      id: "add-to-workspace",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      hiddenWhen: { not: { state: "hasPromotableFiles" } },
    },
    {
      id: "share",
      surfaces: ["selection-bar"],
      presentation: "icon-button",
      hiddenWhen: predicates.cannotShare,
    },
    {
      id: "bulk-delete",
      surfaces: ["selection-bar", "context-menu", "left-rail"],
      presentation: {
        "selection-bar": "icon-button",
        "context-menu": "menu-item",
        "left-rail": "menu-item",
      },
    },
  ],
};
